module.exports = __webpack_public_path__ + "static/media/map_pin.7a5a7453.svg";